/**
 * This error happens when after failed betplacment the undo cash out process failed.
 */
import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { BetslipError, ErrorOrigin } from '../betslip-error';
import { ClientErrorType } from '../client-error-type';

export class UndoCashOutFailedError extends BetslipError {
    constructor() {
        super();
        this.priority = -1001;
        this.origin = ErrorOrigin.BetPlacement;
        this.icon = BetPlacementErrorIcon.Error;
        this.type = ClientErrorType.UndoCashOutFailedError;
    }
}
